import React from "react";
import styled from "styled-components";

const Note = styled.p`
  max-width: none;
`;

const List = styled.ul`
max-width: none;
`;

const CubeWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Cubes = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const Cube = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 1rem;
  font-size: 1rem;

  &:after {
    content: attr(title);
    display: block;
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const CubeYellow = styled(Cube)`
  width: var(--space-xs);
  height: var(--space-xs);
  background-color: #EBCC83;
`;

const CubeBlue = styled(Cube)`
  width: var(--space-s);
  height: var(--space-s);
  background-color: #A0E6EB;
`;

const CubeGreen = styled(Cube)`
  width: var(--space-m);
  height: var(--space-m);
  background-color: #C8EBA0;
`;

const CubePurple = styled(Cube)`
  width: var(--space-l);
  height: var(--space-l);
  background-color: #A0AFEB;
`;

const CubePink = styled(Cube)`
  width: var(--space-xl);
  height: var(--space-xl);
  background-color: #DBABE9;
`;

const CubeRed = styled(Cube)`
  width: var(--space-xxl);
  height: var(--space-xxl);
  background-color: #EB9595;
`;

const Square = styled.div`
  width: 1rem;
  height: 1rem;
  display: inline-block;
  margin-right: 5px;  
`;

const SquareYellow = styled(Square)`
  background-color: #EBCC83;
`;

const SquareBlue = styled(Square)`
  background-color: #A0E6EB;
`;

const SquareGreen = styled(Square)`
  background-color: #C8EBA0;
`;

const SquarePurple = styled(Square)`
  background-color: #A0AFEB;
`;

const SquarePink = styled(Square)`
  background-color: #DBABE9;
`;

const SquareRed = styled(Square)`
  background-color: #EB9595;
`;

const Spacing = () => (
  <>
    <Note>Arc’teryx layouts often employ active white space, or what we prefer to call "considered white space", inferring that it has been designed into the layout with conscious effort.</Note>
    <Note>Elements on a webpage require white space to physically and conceptually separate them from the elements that come before and after them.</Note>
    <Note>We measure our spacing by setting a default value of 1rem equal to 16 pixels.</Note>
    <Note>As the viewport grows smaller or larger our vertical spacing rules will also respond proportionally.</Note>
    <CubeWrap>      
      <Cubes>
        <CubeYellow title="XS"></CubeYellow>
        <CubeBlue title="S"></CubeBlue>
        <CubeGreen title="M"></CubeGreen>
        <CubePurple title="L"></CubePurple>
        <CubePink title="XL"></CubePink>
        <CubeRed title="XXL"></CubeRed>
      </Cubes>
    </CubeWrap>
    <p>Figma <a href="https://www.figma.com/file/xiTC7i82LbrfGrMQRqsxLY/Arc'teryx-Components?node-id=229%3A5039&mode=dev">reference</a></p><br />
    <List>
      <li><SquareYellow />var(--space-xs): space-xs is used on certain form elements.</li>
      <li><SquareBlue />var(--space-s): space-s is base value.</li>
      <li><SquareGreen />var(--space-m): space-m creates space between standalone elements on a webpage. space-m spacing separates tertiary elements within a space-xl section.</li>
      <li><SquarePurple />var(--space-l): space-l separates the header/breadcrumb. space-l spacing separates seconday elements within a space-xl section.</li>
      <li><SquarePink />var(--space-xl): space-xl separates and creates unique sections on a webpage.</li>
      <li><SquareRed />var(--space-xxl): space-xxl separates the page bottom of the page content from the bird signature and/or footer.</li>
    </List>
  </>
);

export default Spacing;
